import { render, staticRenderFns } from "./DailyQuestionnaire.vue?vue&type=template&id=1efdd5f0&scoped=true"
import script from "./DailyQuestionnaire.vue?vue&type=script&lang=js"
export * from "./DailyQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./DailyQuestionnaire.vue?vue&type=style&index=0&id=1efdd5f0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efdd5f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efdd5f0')) {
      api.createRecord('1efdd5f0', component.options)
    } else {
      api.reload('1efdd5f0', component.options)
    }
    module.hot.accept("./DailyQuestionnaire.vue?vue&type=template&id=1efdd5f0&scoped=true", function () {
      api.rerender('1efdd5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/DailyQuestionnaire.vue"
export default component.exports